export default {
    300: "#D3D6E0",
    500: "#C0C7DB",
    700: "#9A9FAF",
};
